export default {
  app: {
    name: 'EONLAND',
  },
  language: {
    local: '中文（简体）',
    chinese: '中文（简体）',
    english: 'English',
  },
  login: {
    email: '邮箱',
    username: '账号',
    password: '密码',
    login: '登录',
    emailReg: '请输入邮箱',
    emailCorrectReg: '请输入正确的邮箱',
    usernameReg: '请输入账号',
    passwordReg: '请输入密码',
    countryReg: '请选择国家',
    loginSuccess: '登录成功',
    appDownload: 'App下载',
    welcomeTo: '欢迎访问',
    signIn: '登录',
    rememberPassword: '记住密码',
    forgotPassword: '忘记密码？',
    forgotPassword2: '忘记密码',
    createAccount: '创建新账号',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    privacyPolicy: '隐私政策',
    termsOfUse: '使用条款',
    termsOfUsePrivacyPolicy: '使用条款&隐私政策',
    copyRight: '版权所有 © 2022-{year} {company}',
    logout: '登出',
    scanLogin: 'APP扫码登录',
    open: '打开',
    app: 'APP',
    openScanLogin: '扫码登录',
    emailLogin: '邮箱登录',
    codeExpired: '二维码已过期',
    capsLockTurnedOn: '大写锁定已打开',
    EONPowerlandApp: '{sysName} APP',
    refreshQrcode: '刷新',
  },
  home: {
    selectLanguage: '选择语言',
    overview: '概况',
    plant: '电站',
    device: '设备',
    user: '用户',
    log: '日志',
    admin: '管理员',
    inverter: '逆变器',
    plantDetail: '电站详情',
    organization: '组织',
    firmware: '固件',
    operation: '运维',
    instruction: '指令集',
    gridProfile: '并网管理',
    orgAndUser: '组织&用户',
    addPlant: '新增电站',
    fault: '事件',
    faultConfig: '故障配置',
    agencyUpdateMessage: '所在组织权限发生变动，请重新登录',
    userDeleteMessage: '当前用户已被删除，请更换账号重新登录或重新创建账号',
  },
  request: {
    timeout: '请求超时',
    networkError: '网络错误,请重试',
    serverError: '服务器错误',
    loginExpires: '登录过期',
  },
  overviews: {
    totalSize: '总容量',
    realTimePower: '实时功率',
    kw: 'kW',
    kwh: 'KWh',
    mwh: 'MWh',
    dailyYield: '当天发电量',
    monthlyYield: '当月发电量',
    yearlyYield: '当年发电量',
    totalYield: '总发电量',
    income: '收益',
    dailyIncome: '当天收益',
    currencyUnit: '¥',
    ton: '吨',
    kg: '千克',
    CO2EmissionReduction: 'CO₂减排量',
    plants: '电站总数',
    totalInverter: '逆变器总数',
    onlineInverters: '在线逆变器',
    totalPCS: '储能变流器总数',
    totalPowerSensor: '电表总数',
    home: '家庭耗能',
    pv: '光伏发电',
    toGrid: '馈网电量',
    discharge: '电池放电',
    charge: '电池充电',
    day: '日',
    month: '月',
    year: '年',
    all: '全部',
    lifetime: '全部',
    pickAYear: '请选择年份',
    selfUse: '自发自用',
    feedInEnergy: '并网电量',
    feedOutEnergy: '离网发电量',
    powerGeneration: '发电量',
    powerConsumption: '耗电量',
    fromGrid: '来自电网',
    electricityManagement: '电价管理',
    electricityPrice: '电价',
    monetaryUnit: '货币单位',
    monetaryUnitReg: '请选择货币单位',
    coefficientReg: '请输入电价',
    coefficientCorrectReg: '请输入正确的电价',
    period: '时段',
    startTimeReg: '请选择开始时间',
    endTimeReg: '请选择结束时间',
    startTime: '开始时间',
    endTime: '结束时间',
  },
  plant: {
    inverterSN: '逆变器SN',
    plantName: '电站名称',
    ownerEmail: '所属用户',
    originalOwnerEmail: '原所属用户',
    registrationNO: '电站ID',
    status: '状态',
    country: '国家/地区',
    type: '类型',
    place: '详细地址',
    timeZone: '时区',
    lon: '经度',
    lat: '纬度',
    address: '详细地址',
    images: '图片',
    drag: '将文件拖到此处，或',
    or: 'or',
    click: '点击上传',
    only: '只能上传jpg/png/jpeg/bmp文件',
    uploading: '上传中...',
    imageReg: '上传格式不正确，请上传jpg/png/jpeg/bmp格式',
    fileReg: '图片大小不能超过5MB!',
    plantNameReg: '请输入电站名称',
    addDevice: '添加网关/设备',
    ratedGatewaySNReg: '请输入网关',
    addDeviceSN: '添加设备',
    delete: '删除',
    deleteReminder: '解绑网关将会把与当前网关关联的其它设备一并从电站中解绑! ',
    addGateway: '添加网关',
    unbindDevice: '解绑设备',
    unbindGateway: '解绑网关',
    addGatewayMsg: '请先添加网关',
    gatewaySN: '网关SN',
    plantRelationShip: '电站架构图',
    emailVerification: '邮箱验证',
    plantEditConfirm: '修改国家或者修改所属用户可能会导致其并网文件更新，是否确认修改？',
    message: '消息',
    upgradeMesg: '新固件版本发布了！',
    dailyLoad: '当天家庭耗能',
    dailyToGrid: '当天馈网',
    dailyFromGrid: '当天来自电网',
    acPower: '光伏发电',
    Pload: '家庭耗能',
    PGridMeter: '电网',
    PBatBMS: '电池',
    upgradeMode: '微逆升级方式',
    upgradeModeReg: '请选择升级方式',
  },
  device: {
    deviceSN: '设备SN',
    deviceType: '设备类型',
    deviceModel: '设备型号',
    plant: '电站',
    deviceName: '设备名字',
    loginAccount: '登录账号',
    batchImport: '批量导入',
    batchDelete: '批量删除',
    batchExport: '批量导出',
    batchEdit: '批量编辑',
    expireDate: '质保时间',
    firmwareVersion: '固件版本',
    hardwareVersion: '硬件版本',
    deviceSNReg: '请输入设备SN',
    deviceSNExceed: '设备SN超过50个字符',
    deviceSNCorrectReg: '设备SN仅支持字母数字',
    deviceNameReg: '请输入设备名字',
    deviceNameExceed: '设备名字超过50个字符',
    deviceTypeReg: '请选择设备类型',
    deviceTypeEnterReg: '请输入设备类型',
    deviceTypeEnterCorrectReg: '请输入正确的设备类型',
    deviceModelReg: '请输入设备型号',
    deviceModelExceed: '设备型号超过50个字符',
    ratedPowerReg: '请输入装机容量',
    ratedPowerCorrectReg: '请输入正确的装机容量',
    ratedPowerDigitReg: '装机容量小数点前最多8位，小数点后最多3位',
    powerReg: '请输入功率',
    powerCorrectReg: '请输入正确的功率',
    powerDigitReg: '功率小数点前最多8位，小数点后最多3位',
    expireDateReg: '请选择质保时间',
    expireDateEnterReg: '请输入质保时间',
    expireDateEnterCorrectReg: '请输入正确的质保时间',
    hardwareVersionReg: '请输入硬件版本',
    hardwareVersionCorrectReg: '请输入正确的硬件版本，0.0.0 ~ 255.255.255',
    hardwareVersionCorrectReg2: '请输入正确的硬件版本，V0.0.0 ~ V255.255.255',
    firmwareVersionCorrectReg: '请输入正确的固件版本，0.0.0 ~ 255.255.255',
    firmwareVersionCorrectReg2: '请输入正确的固件版本，V0.0.0 ~ V255.255.255',
    statusReg: '请选择状态',
    statusEnterReg: '请输入状态',
    statusEnterCorrectReg: '请输入正确的状态',
    plantRegistrationNO: '电站ID',
    downloadBatchImportTemplate: '下载模版',
    agencyNoExistError: '组织编号不存在，请检查文件',
    macReg: '请输入MAC地址',
    macCorrectReg: '请输入正确的MAC地址，MAC地址格式形如 XX:XX:XX:XX:XX:XX',
    microInverterParameterSet: '微逆参数设置',
    gatewayParameterSet: '网关参数设置',
    workingStatus: '工作状态',
    atLeastOneModified: '至少需要修改一项',
    selectFileUpload: '选择文件上传',
    select: '选择',
    incompleteUpgrades: '未完成的升级',
    upgradedInfo: '升级信息',
    COperMode: '运行模式使能位',
    CFunc: '功能模式使能位',
    CProtect: '保护功能使能位',
    CSOutLimit: '输出视在功率上限',
    CSInLimit: '输入视在功率上限',
    CPOutLimit: '输出有功功率上限',
    CPInLimit: '输入有功功率上限',
    CPerOutLimit: '输出有功功率百分比上限',
    CPerInLimit: '输入有功功率百分比上限',
    CQpLimit: '无功功率上限',
    CQnLimit: '无功功率下限',
    CLormsLimit: '输出电流上限',
    CPSet: '有功功率',
    CQSet: '无功功率',
    CPFSet: '功率因素',
    CSafety: '微逆安规类型',
    CTransPeriod: '调试信息上报周期',
    CRecordTime: '调试信息上报持续时间',
    sureRestore: '是否恢复出厂设置',
    sureRestart: '是否重启',
    sureStartDebug: '是否开始调试',
    CldUpdPeriod: '云端上报周期',
    selectTime: '请先选择时间',
    cldUpdPeriodReg: '需大于等于60秒',
    cancelUpgradeFailed: '微型逆变器%s取消升级失败',
    upgradeTimeout: '超时',
    reportModelDiff: '与上报的测试型号(XXX)不一致',
  },
  fault: {
    status: '状态',
    faultCode: '故障码',
    faultType: '故障类型',
    alarmName: '故障名称',
    alarmLevel: '故障等级',
    occurrenceTime: '故障时间',
    recoveryTime: '恢复时间',
    faultReason: '故障原因',
    processingRecommendations: '处理意见',
    emailPush: '邮箱推送',
    isCover: '强制覆盖',
    alarmNameReg: '请输入故障名称',
    faultCodeReg: '请输入故障码',
    faultTypeReg: '请输入故障类型',
    dispose: '处理',
  },
  user: {
    userRole: '用户角色',
    email: '邮箱',
    phone: '电话',
    comment: '备注',
    lastLoginTime: '最后一次登录时间',
    organizationNo: '组织编号',
    organizationName: '组织名字',
    organizationLevel: '代理商级别',
    superiorOrganization: '上级代理商',
    superiorOrganizationNo: '上级代理商编号',
    superiorOrganizationName: '上级代理商名字',
    organizationType: '组织类型',
    contact: '联系人',
    country: '国家/地区',
    userAdd: '新增用户',
    userEdit: '修改用户',
    userRoleReg: '请选择用户角色',
    emailReg: '请输入邮箱',
    emailCorrectReg: '请输入正确的邮箱',
    passwordReg: '请输入密码',
    passwordCorrectReg: '请输入至少6位的字符',
    countryReg: '请选择国家/地区',
    addressReg: '请输入详细地址',
    organizationReg: '请选择组织',
    confirmPasswordReg: '请输入确认密码',
    confirmPasswordCorrectReg: '密码和确认密码不一致',
    oldPasswordMatchReg: '密码不能和旧密码一样',
    password: '密码',
    confirmPassword: '确认密码',
    installer: '安装商',
    primaryAgent: '一级代理商',
    secondaryAgent: '二级代理商',
    thirdLevelAgent: '三级代理商',
    fourthLevelAgent: '四级代理商',
    fifthLevelAgent: '五级代理商',
    organizationNoReg: '请输入组织编号',
    organizationNoCorrectReg: '组织编号仅支持字母数字',
    organizationNameReg: '请输入组织名字',
    isInstallerReg: '请选择是否是安装商',
    authCodeReg: '请输入验证码',
    authCodeCorrectReg: '请输入正确的验证码',
    verificationCode: '验证码',
    i_agree: '我同意',
    terms_of_use: '《使用条款》',
    i_have_red: '，并已阅读',
    i_have_read_and_agree: '我已阅读并同意',
    terms_of_use_privacy_policy: '《使用条款&隐私政策》',
    privacy_policy: '《隐私政策》',
    isCheckReg: '请选择',
    editPassword: '修改密码',
    versionInfo: '版本信息',
    oldPassword: '旧密码',
    oldPasswordReg: '请输入旧密码',
    installerNotify: '如果设置为安装商，它将没有下级代理商',
    preAgencyIdReg: '请选择上级代理商',
    editPersonInfo: '修改个人信息',
    personInfo: '个人信息',
    sureToAddUser: '是否立刻去添加用户',
    organizationChart: '组织架构图',
    domain: '域名',
    allowLoginMain: '主域名允许登录',
    companyZh: '公司中文名',
    companyEn: '公司英文名',
    addressZh: '公司中文地址',
    addressEn: '公司英文地址',
    emailLogo: '邮件logo',
    user: '邮件帐号',
    host: '邮件服务器',
    port: '邮件服务器端口号',
    loginLogo: '登录界面logo',
    webLogo: '主界面logo',
    appLogo: 'APP下载界面logo',
    webSiteEn: '英文官网',
    webSiteZh: '中文官网',
    webSiteCorrectReg: '请输入正确的网站，需以http://或者https://开头',
  },
  log: {
    operator: '操作者',
    log: '日志',
  },
  inverter: {
    inverter: '逆变器',
    registrationNO: '注册号',
    lastUpdated: '上次更新',
    colon: '：',
    acPower: '交流功率',
    dailyYield: '当天发电量',
    totalYield: '总发电量',
    pvPower: 'PV功率',
    energyDiagram: '发电量',
    pv1Voltage: 'PV1电压',
    pv1Current: 'PV1电流',
    pv1Power: 'PV1功率',
    outputVoltage: '输出电压',
    outputCurrent: '输出电流',
    outputPower: '输出功率',
    outputFrequency: '输出频率',
    photovoltaic: '光伏',
    energyStorage: '储能',
    powerGrid: '电网',
    load: '负载',
    pv: 'PV',
    inverterAnalysis: '逆变器统计分析',
    inverterData: '逆变器数据',
    statisticReport: '统计数据',
    reportType: '报表类型',
    pvModule: '光伏组件',
    noData: '暂无数据',
    pvModuleReg: '请选择光伏组件',
    timeReg: '请选择时间',
    saveAsImage: '保存为图片',
    exportXlsx: '导出Xlsx',
    dashboard: '电站概览',
    layoutDesign: '布局设计',
    overview: '概览',
    physicalLayout: '物理布局',
  },
  firmware: {
    firmwareName: '固件名字',
    firmwareList: '固件列表',
    version: '版本',
    versionPlaceHolder: '硬件或固件版本',
    firmware: '固件',
    firmwareUpload: '固件上传',
    uploadFail: '上传失败',
    firmwareReg: '请选择固件',
    upload: '上传',
    fileSize500M: '文件大小不能超过500M',
    firmwareExist: '固件已经存在',
    firmwareNameNotify: '固件文件名字前缀xx_V0.0.0~xx_V255.255.255，xx必须是包含字母或数字或-或_的若干字符, 后缀需是.bin或者.hex',
    firmwareNameEndReg: '固件文件名字需以.bin或者.hex结尾',
    firmwareNameCorrectReg: '请选择正确的固件文件，文件名字前缀xx_V0.0.0~xx_V255.255.255，xx必须是包含字母或数字或-或_的若干字符',
    firmwareNameExceed: '固件文件名字超过64个字符',
    firmwareType: '固件类型',
    firmwareTypeReg: '请选择固件类型',
    firmwareTypeRepeatedReg: '固件类型XXX重复',
  },
  grid: {
    gridProfile: '并网文件',
    gridConfigurationManagement: '并网配置管理',
    profileName: '并网文件名',
    name: '名称',
    value: '值',
    unit: '单位',
    range: '范围',
    profileNameReg: '请输入并网文件名',
    versionReg: '请输版本号',
    versionCorrectReg: '请输入正确的版本号，V0.0.0 ~ V999.999.999',
    leading: '超前',
    lagging: '滞后',
    StdCNVol: '交流侧电压 。标准并网电。',
    StdCLv1: '第一交流侧欠压保护值。第一段输出低压保护值。',
    StdCLv1Mtt: '达到LV1之后，断开电网的时间。',
    StdCHv1: '第一交流侧过压保护值。第一段输出高压保护值。',
    StdCHv1Mtt: '达到HV1之后，断开电网的时间。',
    StdCLv2: '第二交流侧欠压保护值。第二段输出低压保护值。',
    StdCLv2Mtt: '达到LV2之后，断开电网的时间。',
    StdCHv2: '第二交流侧过压保护值。第二段输出过压保护值。',
    StdCHv2Mtt: '达到HV2之后，断开电网的时间。',
    StdCNFre: '并网频率',
    StdCLf1: '最低频率保护点',
    StdCLf1Mtt: '达到最低保护点后的离网保护时间',
    StdCHf1: '最高频率保护点',
    StdCHf1Mtt: '达到最高保护点后的离网保护时间',
    StdCIdEn: '孤岛保护触发标志位',
    StdCRt: '掉电保护之后的重新连接时间',
    StdCRhv: '掉电保护之后重新连接的最大电压',
    StdCRlv: '掉电保护之后重新连接的最小电压',
    StdCRhf: '掉电保护之后重新连接的最大频率',
    StdCRlf: '掉电保护之后重新连接的最小频率',
    StdCRurNm: '正常并网情况下，逆变器输出功率的上升斜率',
    StdCRurSs: '保护后重新连接时，逆变器输出功率的上升斜率',
    StdCFwEn: '输出有功功率根据频率变化功能的标识位',
    StdCFwFstart: '开始降功率的电网频率',
    StdCFwDSlope: '功率下降的斜率',
    StdCFwSss: '功率恢复的斜率',
    StdCApcEn: '输出有功功率控制可以直接通过监控平台下发命令实现，该功能默认开启。同时，本模块中也支持逆变器输出有功功率变化率的修改。',
    StdCSpfEn: 'SPF功能使能标志位',
    StdCSpfLeadLag: '允许运行的功率因数设置',
    StdCVwEn: '输出功率根据输出电压变化功能的使能标志位',
    StdCVwVStart: '功率开始下降的输出电压值',
    StdCVwVEnd: '功率不再下降的输出电压值',
    StdCVwKPower: '本功能下，功率下降的斜率',
    StdCCosEn: 'Cosφ(P) 测试项目使能',
    StdCCosPwPt1: '第一个测试点的功率值百分比',
    StdCCosPwPt2: '第二个测试点的功率值百分比',
    StdCCosPwPt3: '第三个测试点的功率值百分比',
    StdCCosPfPt1: '第一测试点时的PF',
    StdCCosPfPt2: '第二测试点时的PF',
    StdCCosPfPt3: '第三测试点时的PF',
    StdCOptEn: '10分钟过压保护功能使能开关',
    StdCOptVol: '10分钟过压保护时的设定电压值',

    'H/LVRT': '当光伏逆变器输出连接点的电网电压保持在正常范围内，如0.85*Un到1.1Un时，其不会因电网电压变化而断开。同时，该电网电压超出此正常范围时，逆变器需要在要求时间后断开与配电网络的连接。此要求时间定义为“Maximum Trip Time”，电网电压范围上下限定义为“High Voltage”和“Low Voltage”。用户可以根据当地监管部门的要求调整这些参数值。',
    'H/LFRT': '当光伏逆变器输出连接点的电网电压频率保持在正常范围内时，其不会因电网频率变化而断开。同时，该电网频率超出此正常范围时，逆变器需要在要求时间后断开与配电网络的连接。此要求时间定义为“Maximum Trip Time”，电网频率范围上下限定义为“High Frequency”和“Low Frequency”。用户可以根据当地监管部门的要求调整这些参数值。',
    IslandingDetection: '孤岛是指一个或多个本地电力系统与其余电力系统在电气上分离的一种电网运行状态，如本地区域电网与电力公司断开。逆变器应能够检测到这种孤岛情况，然后停止发电。此功能默认开启，不建议进行调整。',
    Reconnection: '当电网电压和频率异常时，光伏逆变器不应发电。但当电网电压和频率在允许范围内后，则允许逆变器连接并开始发电。重新连接的相关设置在Reconnection模块和Ramp Rate模块中。在Reconnection模块中可以修改频率范围、电压范围、重新连接时间等，在Ramp Rate模块中可以设置逆变器输出功率在重连时上升的斜率，需要注意这里需设置的是逆变器正常工作启动还是由于接口保护跳闸后自动重新连接，在 Ramp Rate 模块中，“Normal Ramp up Rate (RUR_NM)”用于正常运行启动，而“Soft Start Ramp up Rate (RUR_SS)”用于接口保护跳闸后的自动重新连接。\n'
      + '用户可以根据当地监管部门的要求调整这些参数值。',
    RampRates: '当电网电压和频率异常时，光伏逆变器不应发电。但当电网电压和频率在允许范围内后，则允许逆变器连接并开始发电。重新连接的相关设置在Reconnection模块和Ramp Rate模块中。在Reconnection模块中可以修改频率范围、电压范围、重新连接时间等，在Ramp Rate模块中可以设置逆变器输出功率在重连时上升的斜率，需要注意这里需设置的是逆变器正常工作启动还是由于接口保护跳闸后自动重新连接，在 Ramp Rate 模块中，“Normal Ramp up Rate (RUR_NM)”用于正常运行启动，而“Soft Start Ramp up Rate (RUR_SS)”用于接口保护跳闸后的自动重新连接。\n'
      + '用户可以根据当地监管部门的要求调整这些参数值。',
    FrequencyWatt: 'Frequency Watt模块用于调节逆变器有功输出功率对电网频率的响应，如下图所示即为本模块功能对应的曲线图示，当光伏逆变器输出电网电压频率高于Fstart时，逆变器输出功率将以斜率Kpower_Freq下降。\n'
      + '用户可以根据当地监管部门的要求调整这些参数值。',
    ActivePowerControl: '输出有功功率控制可以直接通过监控平台下发命令实现，该功能默认开启。同时，本模块中也支持逆变器输出有功功率变化率的修改。',
    SpecifiedPowerFactor: '并网保护文件中的Volt Var模块、SPF模块、WPF模块、RPC模块等均与无功补偿功能相关。对于支持无功补偿功能的微逆机型，这些模块默认不开启，若需开启仅能开启其中一个。\n'
      + '\n'
      + '在某些情况下，逆变器需设置一个指定的功率因数以满足当地要求。微型逆变器支持的固定功率因数设置最大范围为 0.8 导致 0.8 滞后。\n'
      + '\n'
      + '注1：功率因数是有功功率P的绝对值与视在功率S的比值。\n'
      + '注2：滞后功率因数定义为从电网角度看逆变器作为感性负载。超前功率因数定义为从电网角度看逆变器作为容性负载。\n'
      + '注3：如果用户想设置功率因数为 0.95 领先，则需要在本模块中选择领先并填入0.95。',
    VoltWatt: 'Volt Watt模块表示的是逆变器输出功率与输出电网电压之间的关系，如下图所示，当电网电压高于Vstart时，输出功率将以斜率Kpower_Volt下降。用户可以根据当地监管部门的要求调整这些参数值。',
    CosCurve: '',
    currentUsage: '当前使用',
    sysConfigure: '系统配置',
    userConfigure: '用户配置',
    distributeGridProfile: '是否下发当前并网文件',
    deleteCurrentUseProfile: '<strong style="color: #606266">XXX</strong> 正在 <strong style="color: #606266">YYY</strong> 使用，删除将导致该国家地区下所有电站的并网文件更新，确定要删除?',
  },
  errorPage404: {
    errorInfo: '请检查您输入的网址是否正确，或点击下面的按钮返回主页。',
    returnHome: '返回首页',
  },
  common: {
    default: '默认',
    creationTime: '创建时间',
    updateTime: '更新时间',
    operation: '操作',
    installationTime: '安装时间',
    ratedPower: '装机容量（W）',
    powerw: '功率(W)',
    search: '搜索',
    export: '导出',
    number: '序号',
    clear: '清除',
    time: '时间',
    keyword: '关键字',
    add: '新增',
    kw: 'kW',
    mwh: 'MWh',
    kwh: 'KWh',
    w: 'W',
    v: 'V',
    a: 'A',
    celsiusDegree: '℃',
    var: 'Var',
    kVarh: 'KVarh',
    hz: 'Hz',
    percentSign: '%',
    va: 'VA',
    voltage: '电压',
    current: '电流',
    power: '功率',
    yield: '发电量',
    sure: '确认',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    save: '保存',
    addSuccess: '新增成功',
    editSuccess: '修改成功',
    deleteSuccess: '删除成功',
    resetSuccess: '重置成功',
    createSuccess: '创建成功',
    updateSuccess: '修改成功',
    uploadSuccess: '上传成功',
    saveSuccess: '保存成功',
    setSuccess: '设置成功',
    setFailed: '设置失败',
    setTimeout: '设置超时',
    commandResponseFailed: '指令响应失败',
    issuedSuccess: '指令下发成功',
    canceledSuccessfully: '取消成功',
    deliveredSuccess: '下发成功',
    unbindSuccess: '解绑成功',
    yes: '是',
    no: '否',
    detail: '详情',
    remind: '提醒',
    sureDelete: '确定要删除',
    sureDisassociation: '确定取消关联',
    sureUnbind: '确定要解绑',
    pleaseSelect: '请选择',
    comment: '备注',
    status: '状态',
    bathImportSuccess: '批量导入成功',
    back: '返回',
    send: '发送',
    second: '秒',
    version: '版本号',
    dataEmpty: '数据为空',
    commaSymbol: '，',
    spaceSymbol: ' ',
    copySuccess: '复制成功',
    mac: 'MAC地址',
    pleaseEnterReg: '不能为空',
    greaterThanOrEqualToZeroReg: '需大于等于0',
    greaterThan0: '需大于0',
    numberReg: '需是数值型',
    leftBracket: '（',
    rightBracket: '）',
    showColumns: '显示列',
    forceDeleteRemind: '是否强制删除？',
    questionMarkSymbol: '？',
    submit: '提交',
    upgrade: '升级',
    cancelUpgrade: '取消升级',
    sureCancelUpgrade: '确定要取消升级',
    finish: '完成',
    done: '完成',
    close: '关闭',
    nextStep: '下一步',
    previousStep: '上一步',
    sureUpgrade: '确定要升级xxx的固件',
    sureUpgradePlant: '请确认是否升级xxx下全部微逆、网关和储能变流器设备',
    hour: '小时',
    minute: '分钟',
    runTime: '运行时间',
    upgradeTime: '升级时间',
    batchCancel: '批量取消',
    cannotBeEmpty: '不能为空',
    debug: '开始调试',
    restart: '重启',
    restoreFactorySettings: '恢复出厂设置',
    oneClickCancel: '一键取消微逆升级',
    upgradeCanceled: '升级取消',
    upgradeSuccessfully: '升级成功',
    upgradeFailed: '升级失败',
    valueError: '值错误',
    enterRange: '输入范围',
    instructions: '说明',
    ok: '知道了',
    lowerLimit: '下限',
    upperLimit: '上限',
    lowerLimitCorrectReg: '下限不能大于上限',
    upperLimitCorrectReg: '上限不能小于下限',
    invalidInput: '非法输入',
    moreOperations: '更多操作',
    colon: '：',
    multipleSelect: '支持多选',
    websiteSettings: '网站设置',
    uploadImageFile: '请上传图片格式的文件',
  },
  time: {
    paceSymbol: '',
    year: '年',
    day: '日',
    hour: '时',
    minute: '分',
    second: '秒',
  },
  defines: {
    admin: '管理员',
    agency: '代理商',
    installer: '安装商',
    user: '终端用户',
    inverter: '微型逆变器',
    gateway: '网关',
    meter: '电表',
    pcs: '储能变流器',
    notDelivered: '未出厂',
    leaveTheFactory: '出厂',
    installed: '已安装',
    underMaintenance: '维修中',
    scrap: '报废',
    normal: '正常',
    faulty: '故障',
    offline: '离线',
    online: '在线',
    EbatInA: '电池总充电电能',
    EbatInT: '电池当天充电电能',
    EbatOutA: '电池总放电电能',
    EbatOutT: '电池当天放电电能',
    EepsInA: '离网交流端三相当天输出电能',
    EepsOutA: '离网交流端三相总输出电能',
    EgridInA: '并网交流端三相总输入电能',
    EgridInT: '并网交流端三相单天输入电能',
    EgridOutA: '并网交流端三相总输出电能',
    EgridOutT: '并网交流端三相单天输出电能',
    EpvA: '光伏总发电电能',
    EpvT: '光伏当天发电电能',
    EqGridInA: '并网交流端三相总输出无功能量',
    EqGridInT: '并网交流端三相单天输出无功能量',
    EqGridOutA: '并网交流端三相总输出无功能量',
    EqGridOutT: '并网交流端三相单天输出无功能量',
    Fac: '交流侧三相电压频率',
    Iac: '交流侧三相电流',
    Idc: 'PV侧电流',
    PFac: '交流侧三相功率因素',
    Pac: '输出功率',
    Pdc: 'PV侧功率',
    Qac: '交流侧三相无功功率',
    Sac: '交流侧三相视在功率',
    StError: '逆变器故障信息',
    StFunc: '逆变器功能模式',
    StMode: '逆变器运行模式',
    StRuntime: '逆变器运行时间',
    StWork: '逆变器开关状态',
    TEepsInA: '离网交流端当天输出电能',
    TEepsOutA: '离网交流端总输出电能',
    TEgridInA: '并网交流端总输入电能',
    TEgridInT: '并网交流端单天输入电能',
    TEgridOutA: '并网交流端总输出电能',
    TEgridOutT: '并网交流端单天输出电能',
    TEqGridInA: '并网交流端总输出无功能量',
    TEqGridInT: '并网交流端单天输出无功能量',
    TEqGridOutA: '并网交流端总输出无功能量',
    TEqGridOutT: '并网交流端单天输出无功能量',
    TPFac: '交流侧功率因素ABC三相之和',
    TPac: '交流侧有功功率ABC三相之和',
    TQac: '交流侧无功功率ABC三相之和',
    TSac: '交流侧视在功率ABC三相之和',
    Tbat: '电池侧功率电路温度',
    Tc: '内部环境温度',
    Tinv: '逆变侧功率电路温度',
    Tpv: 'PV侧功率电路温度',
    Vac: '输出电压',
    Vdc: 'PV侧电压',
    dispose: '已处理',
    undisposed: '未处理',
    unrecovered: '未恢复',
    hint: '提示',
    warning: '警告',
    error: '错误',
    fatal: '严重错误',
    minutes1: '1分钟',
    minutes5: '5分钟',
    minutes10: '10分钟',
    minutes15: '15分钟',
    otaModeAll: '全部一起升级',
    otaModeSingle: '逐一升级',
    otaModeBathch: '分批升级',
  },
  currency: {
    Euro: '欧元',
    USD: '美元',
    RMB: '人民币',
    GBP: '英镑',
    AUD: '澳元',
    INR: '印度卢比',
    NZD: '新西兰元',
    THB: '泰铢',
    BRL: '巴西雷亚尔',
    PLN: '波兰币',
    PHP: '菲律宾比索',
  },
  pcs: {
    operatingMode: '运行模式',
    selfPowered: '自发自用',
    selfPowereddetail: '优先使用太阳能为您的家庭供电，并将多余的太阳能按比例馈网和电池充电',
    reserveSOC: '预留电池电量',
    feedin: '馈网功率比例',
    timeBase: '定时充放',
    timeBaseDetial: '如果一天之中用电费率有所不同，您可以使用此模式，实现夜间电池充电，白天放电',
    backUp: '备电模式',
    backUpSOC: '备电预留电池电量',
    offGridSOC: '离网预留电池电量',
    backUpDetail: '电池维持在设定的电量，以便您随时有储备电量使用',
    charging: '充电',
    discharging: '放电',
    exportingBattery: '电池馈网',
    time: '充/放电时间',
    addTime: '添加时间段',
    startTimeReg: '请选择开始时间',
    endTimeReg: '请选择结束时间',
    startTime: '开始时间',
    endTime: '结束时间',
    sTimeeTimeReg: '开始和结束时间不能都是00:00',
    timeOverlapReg: '时间存在重叠',
  },
  instruction: {
    deviceDebugging: '设备调试',
    instruction: '指令集',
    instructionName: '指令集名称',
    instructionCount: '指令数量',
    operator: '修改者',
    subcommand: '子命令',
    startBit: '起始位',
    outputBit: '输出BIT位',
    control: '控制命令',
    add: '添加',
    readLen: '读取数据长度',
    writeLen: '保存数据长度',
    writeByteLen: '保存数据字节长',
    writeDatas: '保存数据',
    command: '指令',
    send: '下发',
    sendTime: '下发/接收时间',
    data: '数据',
  },
};
